import { RoleId } from '@wix/members-domain-ts';

import { withIcons, unfollowRoleAction, openChatRoleAction } from './actions';
import { findMemberByUid } from '../members/selectors';
import { getIsMobile } from '../site/selectors';

export const getFFRolesActions = (state, memberId) => {
  const member = findMemberByUid(state, memberId);
  const rolesMap = state.roles.map;
  let { rolesActions = [] } = member;

  rolesActions = rolesActions.filter((action) => action.roleId !== RoleId.EDIT);

  return withIcons(rolesActions, rolesMap);
};

export const getMemberBoxRolesActions = (state, memberId, shouldShowChat) => {
  const member = findMemberByUid(state, memberId);
  const rolesMap = state.roles.map;
  let { rolesActions = [] } = member;
  const isMobile = getIsMobile(state);

  if (isMobile && shouldShowChat) {
    if (member.isSubscribed) {
      rolesActions = [...rolesActions, unfollowRoleAction];
    } else {
      rolesActions = [...rolesActions, openChatRoleAction];
    }
  }
  rolesActions = rolesActions.filter((action) => action.roleId !== RoleId.EDIT);

  return withIcons(rolesActions, rolesMap);
};
